import { render, staticRenderFns } from "./ConnectBtn.vue?vue&type=template&id=785ade62"
import script from "./ConnectBtn.vue?vue&type=script&lang=ts"
export * from "./ConnectBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports